import React from "react";
import { ExerciseEditorProps } from "./exercise-editor-types";
import { RecordedExerciseContent } from "@org/ui";
import { Label } from "@org/ui";
import { TextArea } from "@org/ui";
import { Input } from "@org/ui";

export const RecordedExerciseEditor: React.FC<ExerciseEditorProps<RecordedExerciseContent>> = ({
  content,
  updateContent
}) => {
  const handleUpdate = (nextData: Partial<RecordedExerciseContent["data"]>) => {
    updateContent({
      ...content,
      data: {
        ...content.data,
        ...nextData
      }
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor={`correction-${content.id}`}>Correction</Label>
        <TextArea
          id={`correction-${content.id}`}
          value={content.data.correction}
          onChange={(event) => handleUpdate({ correction: event.target.value })}
          placeholder="Optional note on what to listen for"
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor={`duration-${content.id}`}>Maximum Duration (seconds)</Label>
        <Input
          id={`duration-${content.id}`}
          type="number"
          value={content.data.maxDurationSec}
          min={5}
          max={600}
          onChange={(event) => handleUpdate({ maxDurationSec: parseInt(event.target.value, 10) || 60 })}
          className="mt-1"
        />
      </div>
    </div>
  );
};
